export const makeFilteredResultGroupData = resultGroupData => {
  return resultGroupData
    .map(v => v.filter(topic => topic.result !== ''))
    .filter(v => v.length > 0)
}
